import { render, staticRenderFns } from "./printCorporateCIF.vue?vue&type=template&id=4b674dd9&"
import script from "./printCorporateCIF.vue?vue&type=script&lang=js&"
export * from "./printCorporateCIF.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports